import { Marvin, MarvinImage } from '@rarebearsoft/marvin';

const MIN_MARGIN = 20;

export default {
  cropMargins({}, src) {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');

      Object.assign(new Image(), {
        src,
        onerror: reject,
        onload({target}) {
          canvas.width = target.width;
          canvas.height = target.height;

          const image = new MarvinImage();

          image.load(src, () => {
            processImage(image, canvas);

            canvas.toBlob(blob => {
              resolve(URL.createObjectURL(blob));
            })
          });
        },
      });
    });
  }
}

//////////////////////////////////////////////
function processImage(image, canvas) {
  const checkBorder = max => v => v < 0 ? 0 : v > max ? max : v;
  const checkX = checkBorder(image.getWidth());
  const checkY = checkBorder(image.getHeight());
  const [x1, y1, x2, y2] = boundingBox(image);
  const x = checkX(x1 - MIN_MARGIN);
  const y = checkY(y1 - MIN_MARGIN);
  const width = checkX(x2 + MIN_MARGIN) - x;
  const height = checkY(y2 + MIN_MARGIN) - y;
  const cropped = new MarvinImage(1, 1);

  crop(image, cropped, x, y, width, height);

  Object.assign(canvas, { width, height });

  canvas
    .getContext('2d')
    .clearRect(0, 0, canvas.width, canvas.height);

  cropped.draw(canvas);
}

function boundingBox(image) {
  let x1 = 9999, x2 = -1, y1 = 9999, y2 = -1;
  const img = image.clone();

  Marvin.thresholding(img, img, 230);

  for (let y = 0; y < img.getHeight(); y++) {
    for (let x = 0; x < img.getWidth(); x++) {
      // Is Black (Object)?
      if (img.getIntColor(x, y) == 0xFF000000) {
        if (x < x1) x1 = x;
        if (x > x2) x2 = x;
        if (y < y1) y1 = y;
        if (y > y2) y2 = y;
      }
    }
  }
  return [x1, y1, x2, y2];
}

function crop(imageIn, imageOut, x, y, width, height) {
  imageOut.setDimension(width, height);

  for (let i = x; i < x + width; i++) {
    for (let j = y; j < y + height; j++) {
      imageOut.setIntColor(i - x, j - y, imageIn.getIntColor(i, j));
    }
  }
}
